<template>
  <div>

    <Head title="Reports" />
    <h1 class="mb-8 text-3xl">{{ month }} Contacts</h1>
    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Calls</span>
          <h1 class="text-5xl font-bold">{{ callsToday }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-headset text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Texts</span>
          <h1 class="text-5xl font-bold">{{ textsToday }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-sms text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Emails</span>
          <h1 class="text-5xl font-bold">{{ emailsToday }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-envelope text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Contacts Per Lead</span>
          <h1 class="text-5xl font-bold">{{ contactsPerLead }}</h1>
        </div>
        <div>
          <i class="fas fa-chart-bar text-indigo-600 text-4xl" />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-5 mt-8">
      <div class="bg-white rounded-md shadow w-full transition-shadow border rounded-lg shadow-md hover:shadow-xl">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            {{ month }}'s Leaderboard
          </h2>
        </div>
        <div>
          <div class="bg-white rounded shadow mb-5 w-full">
            <table class="text-left p-5 w-full" style="height: 30vh;">
              <thead class="w-full flex bg-gray-100">
                <tr class="w-full flex font-bold p-5">
                  <th class="w-2/6">Loan Officer</th>
                  <th class="w-1/6 text-center">Calls</th>
                  <th class="w-1/6 text-center">Emails</th>
                  <th class="w-1/6 text-center">Texts</th>
                  <th class="w-1/6 text-center">Total</th>
                </tr>
              </thead>
              <tbody class="bg-grey-light flex flex-col items-center overflow-y-scroll w-full" style="height: 30vh;">
                <tr v-for="loanOfficer in leaderboard" :key="loanOfficer.loanOfficer" class="hover:bg-gray-100 flex w-full focus-within:bg-gray-100">
                  <td class="border-t w-2/4 pl-5">
                    <div class="w-full text-m my-2">
                      <div class="font-semibold">
                        {{ loanOfficer.loanOfficer }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.calls }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.emails }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.texts }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4 pr-8">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.total }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="leaderboard.length === 0">
                  <td class="border-t p-2 text-center pt-4" colspan="4">No Leaders.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <h1 class="mb-8 text-3xl mt-8">Lead Counts</h1>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Todays Leads</span>
          <h1 class="text-5xl font-bold">{{ leadsToday }}</h1>
        </div>
        <div>
          <i class="fas fa-user text-indigo-600 text-4xl" />
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Leads 7 Days</span>
          <h1 class="text-5xl font-bold">{{ leadsLastWeek }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-users text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Leads 30 Days</span>
          <h1 class="text-5xl font-bold">{{ leadsThirtyDays }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-users text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ month }} Leads</span>
          <h1 class="text-5xl font-bold">{{ leadsThisMonth }}</h1>
        </div>
        <div>
          <i class="fas fa-users text-indigo-600 text-4xl" />
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ oneMonthAgo }} Leads</span>
          <h1 class="text-5xl font-bold">{{ leadsOneMonthAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-users text-yellow-400 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ twoMonthsAgo }} Leads</span>
          <h1 class="text-5xl font-bold">{{ leadsTwoMonthsAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-users text-green-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>

    <h1 class="mb-8 text-3xl mt-8">Paid Leads</h1>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ month }} Paid Leads</span>
          <h1 class="text-5xl font-bold">{{ paidLeads }}</h1>
        </div>
        <div>
          <i class="fas fa-dollar-sign text-indigo-600 text-4xl" />
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ oneMonthAgo }} Paid Leads</span>
          <h1 class="text-5xl font-bold">{{ paidLeadsOneMonthAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-dollar-sign text-yellow-400 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ twoMonthsAgo }} Ago Paid Leads</span>
          <h1 class="text-5xl font-bold">{{ paidLeadsTwoMonthsAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-dollar-sign text-green-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Year To Date Paid Leads</span>
          <h1 class="text-5xl font-bold">{{ paidLeadsYTD }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-dollar-sign text-red-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>

    <h1 class="mb-8 text-3xl mt-8">Processing Counts</h1>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ month }} Processing</span>
          <h1 class="text-5xl font-bold">{{ processingThisMonth }}</h1>
        </div>
        <div>
          <i class="far fa-newspaper  text-indigo-600 text-4xl" />
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ oneMonthAgo }} Processing</span>
          <h1 class="text-5xl font-bold">{{ processingOneMonthAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="far fa-newspaper  text-yellow-400 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ twoMonthsAgo }} Processing</span>
          <h1 class="text-5xl font-bold">{{ processingTwoMonthsAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="far fa-newspaper text-green-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Year To Date Processing</span>
          <h1 class="text-5xl font-bold">{{ processingYTD }}</h1>
        </div>
        <div>
          <div>
            <i class="far fa-newspaper text-red-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>

    <h1 class="mb-8 text-3xl mt-8">Pre-Approved Counts</h1>
    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ month }} Pre-Approved</span>
          <h1 class="text-5xl font-bold">{{ preApprovedThisMonth }}</h1>
        </div>
        <div>
          <i class="far fa-paper-plane text-indigo-600 text-4xl" />
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ oneMonthAgo }} Pre-Approved</span>
          <h1 class="text-5xl font-bold">{{ preApprovedOneMonthAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="far fa-paper-plane text-yellow-400 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ twoMonthsAgo }} Pre-Approved</span>
          <h1 class="text-5xl font-bold">{{ preApprovedTwoMonthsAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="far fa-paper-plane text-green-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Year To Date Pre-Approved</span>
          <h1 class="text-5xl font-bold">{{ preApprovedYTD }}</h1>
        </div>
        <div>
          <div>
            <i class="far fa-paper-plane text-red-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>
    <h1 class="mb-8 text-3xl mt-8">Closed Counts</h1>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ month }} Closed Volume</span>
          <h1 class="text-5xl">${{ closedThisMonthVolume.toLocaleString() }}</h1>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ oneMonthAgo }} Closed Volume</span>
          <h1 class="text-5xl">${{ closedOneMonthAgoVolume.toLocaleString() }}</h1>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ twoMonthsAgo }} Closed Volume</span>
          <h1 class="text-5xl">${{ closedTwoMonthsAgoVolume.toLocaleString() }}</h1>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">YTD Closed Volume</span>
          <h1 class="text-5xl">${{ closedYTDVolume.toLocaleString() }}</h1>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-4">
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ month }} Closed</span>
          <h1 class="text-5xl font-bold">{{ closedThisMonth }}</h1>
        </div>
        <div>
          <i class="fas fa-bolt text-indigo-600 text-4xl" />
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ oneMonthAgo }} Closed</span>
          <h1 class="text-5xl font-bold">{{ closedOneMonthAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-bolt text-yellow-400 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">{{ twoMonthsAgo }} Closed</span>
          <h1 class="text-5xl font-bold">{{ closedTwoMonthsAgo }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-bolt text-green-600 text-4xl" />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Year To Date Closed</span>
          <h1 class="text-5xl font-bold">{{ closedYTD }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-bolt text-red-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Head, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import moment from 'moment'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {
    leadsToday: Number,
    leadsLastWeek: Number,
    leadsThirtyDays: Number,
    leadsThisMonth: Number,
    leadsOneMonthAgo: Number,
    leadsTwoMonthsAgo: Number,
    leadsTotal: Number,
    paidLeads: Number,
    paidLeadsOneMonthAgo: Number,
    paidLeadsTwoMonthsAgo: Number,
    paidLeadsYTD: Number,
    emailsToday: Number,
    callsToday: Number,
    textsToday: Number,
    closed: Array,
    processingThisMonth: Number,
    processingOneMonthAgo: Number,
    processingTwoMonthsAgo: Number,
    processingYTD: Number,
    preApprovedThisMonth: Number,
    preApprovedOneMonthAgo: Number,
    preApprovedTwoMonthsAgo: Number,
    preApprovedYTD: Number,
    closedThisMonth: Number,
    closedOneMonthAgo: Number,
    closedTwoMonthsAgo: Number,
    closedYTD: Number,
    closedThisMonthVolume: Number,
    closedOneMonthAgoVolume: Number,
    closedTwoMonthsAgoVolume: Number,
    closedYTDVolume: Number,
    leaderboard: Array,
  },
  data() {
    return {
      datacollection: null,
      month: moment().format('MMMM'),
      oneMonthAgo: moment().subtract(1, 'months').format('MMMM'),
      twoMonthsAgo: moment().subtract(2, 'months').format('MMMM'),
    }
  },
  computed: {
    contactsPerLead: function () {
      var contactsTotal = this.emailsToday + this.callsToday + this.textsToday
      var contactsPerLead = contactsTotal / this.leadsThisMonth
      return contactsPerLead.toFixed(2)
    },
  },
  mounted: function () {
    this.$nextTick(this.updateChart)
  },
  methods: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    },
    destroyTask(id) {
      if (confirm('Are you sure you want to delete this task?')) {
        router.delete(('/tasks/' + id), { only: ['tasks'], preserveScroll: true })
      }
    },
    datestamp: function (date) {
      return moment(date).format('MM/DD/YY')
    },
  },
}
</script>
